import { Component, inject, input } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucideArrowLeft, lucidePlus } from '@ng-icons/lucide';
import { ChipComponent } from '@shared/components/chip/chip.component';
import { TrierParPipe } from '@shared/pipes/trier-par.pipe';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';

import { Router } from '@angular/router';
import { ExpansionPanelWithoutBorder } from '@shared/components/expansion-panel-without-border/expansion-panel-without-border.component';
import { Cartographie } from '../../../../cartographie/models/cartographie.model';
import { Aptitude } from '../../../référentiel-métier-processus/processus-aptitude/models/aptitude.model';
import { ProductionItemComponent } from '../production-item/production-item.component';

@Component({
  selector: 'app-aptitude-item',
  imports: [
    HlmButtonImports,
    HlmIconImports,
    ProductionItemComponent,
    TrierParPipe,
    ChipComponent,
    ExpansionPanelWithoutBorder,
  ],
  templateUrl: './aptitude-item.component.html',
  providers: [provideIcons({ lucidePlus, lucideArrowLeft })],
})
export class AptitudeItemComponent {
  readonly #router = inject(Router);

  readonly cartographie = input.required<Cartographie>();
  readonly aptitude = input.required<Aptitude>();
  readonly peutModifier = input.required<boolean>();

  navigateToProcessus() {
    const segments = decodeURIComponent(this.#router.url).split('/');
    segments.pop();
    segments.push('processus');
    this.#router.navigate(segments, {
      queryParams: { idAptitude: this.aptitude().id },
      queryParamsHandling: 'replace',
    });
  }
}
